export default "__VITE_ASSET__D0eufi9b__"